import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {LicenseType} from 'src/openapi/admin/models/LicenseType';
import {getSeatsRangeTitle} from 'src/utils/license-util';


import {
    accountSearchResultLicenseDataSelector,
    accountSearchResultLicenseResultSelector,
} from '../../slices/account-search-result-license.slice';

type Props = {
    accountId: number,
};

export const LicenseSeatsCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultLicenseDataSelector);
    const result = useSelector(accountSearchResultLicenseResultSelector);

    const seatsCount = useMemo(() => {
        if (!result?.data[accountId]) {
            return undefined;
        } else {
            if (LicenseType.US === result?.data[accountId].licenseType) {
                return getSeatsRangeTitle(result?.data[accountId].seatsCount).caption;
            } else {
                return result?.data[accountId].seatsCount;
            }
        }
    }, [result, accountId]);

    if (isLoading || loadingError || !seatsCount) {
        return null;
    }

    return (
        <span>{seatsCount}</span>
    );
};
